import {WdiModalAppProps, WdiModalAppResult, WdiModalProps} from "@/components/WdiControls";
import {DownOutlined} from "@ant-design/icons";
import {Dropdown, Form, Input, Menu, message, Space} from "antd";
import {useEffect, useRef, useState} from "react";
import PageControl, {ModuleType, PageMode} from '@/components/WdiBus/FormPage';
import {formatter, request, ResponseStatus} from "@/utils/request";
import {WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {ProFormInstance} from "@ant-design/pro-form";

type MoreWapperProps = {
  url: string;
  items: any[];
  buttonKeys: string[];
  callback?: (result?: WdiModalAppResult) => void;
};

type ButtonWapperProps = {
  button: API.Button
  items: any[];
  onClose?: (result?: WdiModalAppResult) => void;
  callback?: (result?: WdiModalAppResult) => void;
  onClick?: (result?: WdiModalAppResult) => void;
};
const getItemValue = (items: any[], itemName: string) => {
  let result: any = null;
  items.forEach(item => {
    if (item.name == itemName) {
      result = item.value
      return
    }
  });
  return result
}

enum PolicyButtonType {
  ModifyInTurnUserIds,
  ViewProcessButton,
  InvalidateButton,
}

const UpdateApplyButton: React.FC<ButtonWapperProps> = (props: ButtonWapperProps) => {

  const handleClick = (e: any) => {
    if (props.onClick) {
      props.onClick()
      return;
    }
    const tooltip = props.button?.tooltip;
    if (tooltip && !window.confirm(tooltip)) {
      return;
    }
    request(props.button.url, formatter({
      method: 'POST',
      body: {
        keys: props.button.key,
        items: props.items
      }
    })).then(res => {
      if (res.code != ResponseStatus.SUCCESS) {
        message.error(res.message);
        return;
      }
      submit(res)
    })

  }

  const submit = (res: any) => {
    props.onClose?.(res)
    props.callback?.(res)
  }
  return (
    <>
      <div onClick={handleClick}>
        {props.button.label}
      </div>
    </>
  )
}
export const ProductPolicyMoreWapper: React.FC<MoreWapperProps> = (props: MoreWapperProps) => {
  const [menuItems, setMenuItems] = useState<any[]>([]);
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});

  useEffect(() => {
    const newMenuItems: any[] = [];
    request(props.url, formatter({
      method: 'POST',
      body: {
        keys: props.buttonKeys.join(","),
        items: props.items
      }
    })).then(res => {
      if (res.code == ResponseStatus.SUCCESS) {
        res.data?.forEach((button: API.Button) => {
          newMenuItems.push({
            label: (
              <UpdateApplyButton
                button={button}
                items={props.items}
                onClick={
                  ["InvalidateButton"].includes(button.key) ? () => {
                    setModalProps({
                      visible: true,
                      type: PolicyButtonType.InvalidateButton,
                      data: {button: button, items: props.items}
                    })
                  } : undefined
                }
                callback={(res) => {
                  if (["ReeditPolicyButton", "CopyButton"].includes(button.key)) {
                    PageControl.apply({
                      mode: PageMode.Apply,
                      moduleType: ModuleType.Policy,
                      data: {
                        button: button,
                        productPolicyId: getItemValue(props.items, "productPolicyId"),
                      },
                      onCloseConfirm: () => true,
                      callback: (result) => {
                        props.callback?.(result)
                      }
                    });
                    return;
                  }

                }}
                onClose={() => {
                }}/>
            ),
            key: button.key
          })
        })
      }
      setMenuItems(newMenuItems);
    })
  }, [props.buttonKeys]);

  const InvalidateModalApp: React.FC<WdiModalAppProps> = (props) => {
    const formRef = useRef<ProFormInstance>();

    return (
      <WdiModalForm
        formRef={formRef}
        labelAlign='left'
        layout='horizontal'
        title='无效'
        visible={props.visible}
        modalProps={{
          onCancel: () => {
            props.onClose ? props.onClose() : null;
          },
        }}
        onFinish={async (values) => {
          if (!window.confirm("政策失效后不会再生成此政策的返利，此政策下的待结案的返利单也会自动关闭，且无效后不可撤销，确认吗?")) {
            return;
          }
          const items = [{name: "closeReason", value: values.closeReason}].concat(props.data.items)
          const response = await request(props.data.button.url, formatter({method: 'POST', body: {items: items}}));
          if (response.code == ResponseStatus.SUCCESS) {
            message.success('操作成功');
            if (props.onSave) {
              props.onSave({
                code: ResponseStatus.SUCCESS,
                data: response.data,
              });
            }
          } else {
            message.error(response.message);
          }
        }}
      >
        <Form.Item name='closeReason' label='无效原因' labelCol={{span: 4}} wrapperCol={{span: 20}}
                   rules={[{required: false, message: '无效原因不能为空!'}]}>
          <Input.TextArea style={{resize: 'both'}}/>
        </Form.Item>
      </WdiModalForm>
    );
  };

  return (
    <>
      {
        modalProps.visible && modalProps.type == PolicyButtonType.InvalidateButton &&
        <InvalidateModalApp
          onClose={() => {
            setModalProps({visible: false})
          }}
          onSave={() => {
            props.callback?.()
          }}
          {...modalProps}
        />
      }
      {menuItems && menuItems.length > 0 &&
        <Dropdown overlay={
          <Menu
            items={menuItems}
          />
        }>
          <a onClick={e => e.preventDefault()}>
            <Space>
              More <DownOutlined/>
            </Space>
          </a>
        </Dropdown>
      }
    </>
  )
}


